"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VictoryBrushContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeSvg = require("react-native-svg");
var _victoryBrushContainer = require("victory-brush-container");
var _victoryContainer = require("./victory-container");
var _nativeHelpers = _interopRequireDefault(require("../helpers/native-helpers"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable react/no-multi-comp */
// ensure the selection component get native styles
const RectWithStyle = _ref => {
  let {
    style = {},
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactNativeSvg.Rect, _extends({}, otherProps, _nativeHelpers.default.getStyle(style)));
};
const VictoryBrushContainer = initialProps => {
  const props = (0, _victoryBrushContainer.useVictoryBrushContainer)({
    ...initialProps,
    brushComponent: initialProps.brushComponent ?? /*#__PURE__*/_react.default.createElement(RectWithStyle, null),
    handleComponent: initialProps.handleComponent ?? /*#__PURE__*/_react.default.createElement(RectWithStyle, null)
  });
  return /*#__PURE__*/_react.default.createElement(_victoryContainer.VictoryContainer, props);
};
exports.VictoryBrushContainer = VictoryBrushContainer;
VictoryBrushContainer.role = "container";
VictoryBrushContainer.defaultEvents = initialProps => {
  const props = {
    ..._victoryBrushContainer.VICTORY_BRUSH_CONTAINER_DEFAULT_PROPS,
    ...initialProps
  };
  const createEventHandler = (handler, cancel) =>
  // eslint-disable-next-line max-params
  (event, targetProps, eventKey, context) => {
    if (props.disable) {
      return {};
    }
    if (cancel) {
      _victoryBrushContainer.BrushHelpers.onGlobalMouseMove.cancel();
    }
    return handler(event, {
      ...props,
      ...targetProps
    }, eventKey, context);
  };
  return [{
    target: "parent",
    eventHandlers: {
      onTouchStart: createEventHandler(_victoryBrushContainer.BrushHelpers.onMouseDown, true),
      onTouchMove: createEventHandler(_victoryBrushContainer.BrushHelpers.onGlobalMouseMove, false),
      onTouchEnd: createEventHandler(_victoryBrushContainer.BrushHelpers.onGlobalMouseUp, true)
    }
  }];
};